import React, { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import WhyUs from "@/components/WhyUs";
import Cta from "@/components/Cta";
import Footer from "@/components/Footer";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { err: false };
    }
    static getDerivedStateFromError() {
        return { err: true };
    }
    render() {
        if (this.state.err) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-navy p-8 font-sans text-slate-300">
                    Something went wrong. Please refresh the page.
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09 });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <div className="relative min-h-screen bg-navy font-sans text-slate-100">
                <div className="grain-overlay" aria-hidden="true" />
                <Nav />
                <main>
                    <Hero />
                    <Marquee />
                    <Services />
                    <Manifesto />
                    <WhyUs />
                    <Cta />
                </main>
                <Footer />
            </div>
        </ErrorBoundary>
    );
}

export default App;
